import { toast } from "sonner";
import { Pencil, Trash2 } from "lucide-react";

import { DropdownMenuItem } from "@/components/ui/dropdown-menu";

import { JobOrdersDynamicAttributeById } from "@/hooks/services/pps/handlers/job-orders-dynamic-api";

import { ERROR_SONNER } from "../list/constant";

const EMPTY_SET = new Set<string>();

export function ColumnHeaderActions({
  columnId,
  form,
  setSelectedAttribute,
  showEditDialog,
  showDeleteDialog,
  setShowEditDialog,
  setShowDeleteDialog,
  systemAttributeIds = EMPTY_SET
}: {
  columnId: string;
  form: any;
  showEditDialog: boolean;
  showDeleteDialog: boolean;
  setSelectedAttribute: (attribute: any) => void;
  setShowEditDialog: (show: boolean) => void;
  setShowDeleteDialog: (show: boolean) => void;
  systemAttributeIds?: Set<string>;
}) {
  const attributeId = columnId.split("-")[0];
  const columnIndex = columnId.split("-")[1];
  const isSystem = systemAttributeIds.has(attributeId);
  const handleDialogClick = () => {
    if (attributeId) {
      JobOrdersDynamicAttributeById(attributeId)
        .then((response: any) => {
          setSelectedAttribute({
            ...response.data,
            index: Number(columnIndex) || 0
          });

          form.reset({
            label: response.data.columns.find(
              (f: any) => f.attributeId === Number(attributeId)
            )?.label,
            dataType: response.data.dataType?.toString() || "",
            defaultValue: response.data.defaultValue || "",
            isUnique: response.data.isUnique || false,
            isRequired: response.data.isRequired || false,
            isActive: response.data.isActive !== false
          });
        })
        .catch((error: any) => {
          setSelectedAttribute(null);

          toast("Failed to load attribute", {
            description: error?.message || "Failed to load attribute data",
            ...ERROR_SONNER
          });
        });
    }
  };

  return (
    <>
      <DropdownMenuItem
        onSelect={(e) => {
          e.preventDefault();
          handleDialogClick();
          setShowEditDialog(!showEditDialog);
        }}
      >
        <div className="aero:flex aero:items-center">
          <Pencil className="aero:h-4 aero:w-4 aero:mr-2" />
          Edit Column
        </div>
      </DropdownMenuItem>

      {!isSystem && (
        <DropdownMenuItem
          onSelect={(e) => {
            e.preventDefault();
            handleDialogClick();
            setShowDeleteDialog(!showDeleteDialog);
          }}
        >
          <div className="aero:flex aero:items-center aero:!text-destructive">
            <Trash2 className="aero:h-4 aero:w-4 aero:mr-2 aero:!text-destructive" />
            Delete Column
          </div>
        </DropdownMenuItem>
      )}
    </>
  );
}
